"use client";

import React from "react";
import Typography from "@mui/material/Typography";

// Bullet markers we recognize as list items — includes markdown-style "*"/"-"
// as well as glyphs commonly left behind when pasting bulleted content from
// Word/Google Docs/Slack ("•", "◦", "▪", "‣"), so those still render as real
// <ul>/<li> markup (and are announced as a list) for screen readers instead
// of flattening into plain paragraphs.
const BULLET_PREFIX = /^[*•◦▪‣-]\s+/;

const MarkdownList = ({ content }) => {
  if (!content) {
    return null;
  }

  // Split any inline " <bullet> " runs onto their own line first.
  const replacedContent = content.replace(/ ([*•◦▪‣-]) /g, "\n$1 ");

  // Split at the newlines
  const lines = replacedContent.split("\n");
  const elements = [];
  let listItems = [];

  lines.forEach((line, index) => {
    const trimmed = line.trim();
    if (BULLET_PREFIX.test(trimmed)) {
      listItems.push(
        <li key={index} style={{ marginBottom: "8px" }}>
          <Typography variant="body1" component="span">
            {trimmed.replace(BULLET_PREFIX, "")}
          </Typography>
        </li>
      );
    } else {
      if (listItems.length > 0) {
        elements.push(
          <ul
            key={`ul-${index}`}
            style={{ paddingLeft: "20px", marginTop: "20px", listStyleType: "disc" }}
          >
            {listItems}
          </ul>
        );
        listItems = [];
      }
      elements.push(
        <Typography key={index} style={{ marginBottom: "8px" }}>
          {line}
        </Typography>
      );
    }
  });

  if (listItems.length > 0) {
    elements.push(
      <ul key="ul-final" style={{ paddingLeft: "20px", marginTop: "20px", listStyleType: "disc" }}>
        {listItems}
      </ul>
    );
  }

  return <>{elements}</>;
};

export default MarkdownList;